import { eMucThuSinhVienActionsObj } from "../../action-types/muc-thu/IMucThuSinhVienActionTypes";
import { generateActions } from "../generateActions";

export const mucThuSinhVienActions = {
  ...generateActions(eMucThuSinhVienActionsObj, "MUC_THU_SINH_VIEN"),
};
